
import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight, Brain, Zap, Globe, Users, Shield, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLocale } from '@/contexts/LocaleContext';

export const HomeProductIntro = () => {
  const { convertText } = useLocale();
  
  const features = [{
    icon: Brain,
    title: "AI-Powered Intelligence",
    description: "Advanced machine learning algorithms that adapt and grow with your business needs"
  }, {
    icon: Zap,
    title: "Structured Delivery",
    description: "Milestone-based delivery keeps scope, decisions, and progress visible from discovery to launch"
  }, {
    icon: Globe,
    title: "Complete Business Suite",
    description: "Everything you need - CRM, Analytics, Voice AI, Billing, and custom solutions"
  }, {
    icon: Users,
    title: "Expert Human Touch",
    description: "AI accelerated by real experts ensuring quality and reliability at every step"
  }, {
    icon: Shield,
    title: "Security by Design",
    description: "Access controls, auditability, and secure delivery practices are considered throughout each solution"
  }, {
    icon: Sparkles,
    title: "Future-Ready Platform",
    description: "Scalable architecture that evolves with emerging technologies and your growth"
  }];

  return (
    <section className="relative overflow-hidden bg-gray-50/60 py-16 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        {/* Header Section */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-gradient-to-r from-blue-50 to-cyan-50 rounded-full px-4 py-2 mb-6">
            <Brain className="h-4 w-4 text-blue-600 mr-2" />
            <span className="text-sm font-medium text-blue-900">{convertText('Discover Our Product Ecosystem')}</span>
          </div>
          
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-light text-gray-900 mb-6 tracking-tight leading-tight">
            Transform Your Business with{' '}
            <br />
            <span className="font-medium bg-gradient-to-r from-blue-600 via-cyan-600 to-blue-700 bg-clip-text text-transparent">
              AI-Driven Solutions
            </span>
          </h2>
          
          <p className="text-lg md:text-xl text-gray-600 font-light max-w-4xl mx-auto leading-relaxed">
            From custom websites and web applications to comprehensive backend systems and advanced analytics, our integrated platform combines artificial intelligence with expert human craftsmanship to deliver enterprise-grade solutions that scale with your ambitions.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="group bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
              <div className="mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <feature.icon className="h-6 w-6 text-white" />
                </div>
              </div>
              
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{convertText(feature.title)}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">{convertText(feature.description)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
